import {
  SET_CLIENT,
  SET_TICKETS_FILTERS,
  SET_TICKETS,
  SET_FILTERED_TICKETS,
  SET_TICKETS_LIST_PAGE,
  SET_HAS_NEXT_TICKET_PAGE,
  SET_MESSAGE_HISTORY,
  SET_CLIENT_CHANNELS,
  UPDATE_PERSONAL_INFORMATION,
  ADD_EMAIL_CLIENT,
  ADD_SELECTED_TICKET,
  REMOVE_SELECTED_TICKET,
  SELECT_ALL_TICKETS,
  ADD_PHONES_CLIENT,
  REMOVE_PHONE_CLIENT,
  ADD_ADDRESSES_CLIENT,
  REMOVE_ADDRESSES_CLIENT,
  REMOVE_EMAIL_CLIENT,
  UPDATE_ADDRESSES_CLIENT,
  UPDATE_PHONES_CLIENT,
  UPDATE_EMAIL_CLIENT,
  UPDATE_DATA_CUSTOM,
  SET_CLIENTS_WITH_SAME_NUMBER_FOUND,
  SET_CLIENTS_FOUND,
  SET_CLEAN_RESULTS,
  SET_CONTACTS_CLIENT,
  UPDATE_CONTACTS_CLIENT,
  DELETE_CONTACTS_CLIENT,
  SET_CALL_FINISH,
  SET_TICKET_DETAIL,
  SET_DIALING_TYPE,
  SET_CHANNEL_PERSON_TICKET,
  SET_SPEECH_CONFIG,
  SET_PORTFOLIO_DETAIL,
  SET_TYPIFICATIONS_TABLE_DATA,
  SET_CAPTURE,
  SET_IS_SCHEDULE,
  SET_LAST_OPENED_TICKET,
  SET_INTERACTIONS_CHANNEL,
  SET_EMAIL_HISTORY,
  SET_REFRESH_CHANNELS_ASTERISK_ID,
  SET_EVENT_MESSAGING,
  SET_IS_VISITOR_TYPING,

  SET_CHUNKS,
  SET_CHUNK,
  APPEND_CHUNK,
  SET_CURSORS,
  INSERT_NEW_TICKET,
  REMOVE_TICKET,
  RESET_AFTER_FIRST,
  REBALANCE_ALL_CHUNK_TICKETS,
  RESET_CHUNK,
  CLEAR_SELECTED_TICKETS,
} from "./mutation-types";
import _ from "lodash";

function deduplicateAllChunks(state) {
  const seenIds = new Set();

  state.chunks.forEach(chunk => {
    if (!chunk.tickets) chunk.tickets = [];

    const uniqueTickets = [];
    const localSeen = new Set();

    chunk.tickets.forEach(ticket => {
      if (ticket && !localSeen.has(ticket.id) && !seenIds.has(ticket.id)) {
        uniqueTickets.push(ticket);
        localSeen.add(ticket.id);
        seenIds.add(ticket.id);
      }
    });

    chunk.tickets = uniqueTickets;
  });
}

const mutations = {
  [SET_CLIENT](state, client) {
    state.client = client;
  },
  [SET_TICKETS_FILTERS](state, filters) {
    state.ticketsFilters = filters;
  },
  [SET_TICKETS_LIST_PAGE](state, page) {
    state.ticketListPage = page;
  },
  [SET_HAS_NEXT_TICKET_PAGE](state, hasNext) {
    state.hasNextTicketPage = hasNext;
  },
  // [SET_TICKETS](state, tickets) {
  //   state.tickets = tickets;
  //   const updatedTickets = state.tickets.filter((item) => {
  //     const ticketFound = state.selectedTickets.find((ticket) => ticket.id === item.id);
  //     if (ticketFound) {
  //       return item;
  //     }
  //   });
  //   state.selectedTickets = updatedTickets;
  // },

  [SET_CHUNKS](state, { chunks, channelsCount }) {
    state.chunks = chunks;
    if (channelsCount)  state.channelsChunks = channelsCount;
  },
  // Nueva mutación SET_TICKETS a SET_CHUNK para paginación infinita
  [SET_CHUNK](state, { cursor, tickets, channelsCount }) {
    const idx = state.chunks.findIndex(c => c.cursor === cursor);
    if (idx !== -1) {
      state.chunks[idx].tickets = tickets;
    } else {
      state.chunks.push({ cursor, tickets });
    }
    state.channelsChunks = channelsCount
  },
  // [APPEND_CHUNK](state, { cursor, tickets }) {
  //   state.chunks.push({ cursor, tickets });
  // },
  [RESET_CHUNK](state) {
    state.chunks = [];
    state.nextCursor = null;
    state.prevCursor = null;
  },
  [APPEND_CHUNK](state, { cursor, tickets }) {
    const i = state.chunks.findIndex(c => c.cursor === cursor);
    if (i !== -1) {
      // 🚀 si ya existe → reemplázalo con la versión más fresca
      state.chunks[i].tickets = tickets;
    } else {
      // si no existe → agrega nuevo chunk
      state.chunks.push({ cursor, tickets });
    }
  },
  [SET_CURSORS](state, { nextCursor, prevCursor }) {
    state.nextCursor = nextCursor;
    state.prevCursor = prevCursor;
  },
  [INSERT_NEW_TICKET](state, ticket) {
    // Inserta arriba sin borrar nada
    state.chunks[0].tickets.unshift(ticket);
  },
  [REMOVE_TICKET](state, ticketId) {
    for (const chunk of state.chunks) {
      const idx = chunk.tickets.findIndex(t => t.id === ticketId);
      if (idx !== -1) {
        chunk.tickets.splice(idx, 1);
        break;
      }
    }
  },
  [RESET_AFTER_FIRST](state) {
    if (state.chunks.length > 1) {
      state.chunks = [state.chunks[0]];
    }
  },
  // Rebalance genérico: corrige overflow/underflow en cascada
  [REBALANCE_ALL_CHUNK_TICKETS](state, limit) {
    if (!limit || limit <= 0) return;

    // Asegurar estructura consistente
    state.chunks = state.chunks.filter(c => Array.isArray(c.tickets));

    for (let i = 0; i < state.chunks.length - 1; i++) {
      const current = state.chunks[i];
      const next = state.chunks[i + 1];

      // Si sobra en i, empuja al inicio de i+1
      while (current.tickets.length > limit) {
        const moved = current.tickets.pop();
        if (!next) {
          state.chunks.push({ cursor: state.nextCursor, tickets: [] });
        }
        state.chunks[i + 1].tickets.unshift(moved);
      }

      // Si falta en i, jala del inicio de i+1
      while (current.tickets.length < limit && next?.tickets.length > 0) {
        const moved = next.tickets.shift();
        current.tickets.push(moved);
      }
    }

    // Limpia chunks vacíos al final
    while (state.chunks.length && state.chunks[state.chunks.length - 1].tickets.length === 0) {
      state.chunks.pop();
    }

    // Dedupe global tras el rebalance
    deduplicateAllChunks(state);
  },
  // Fin nueva mutacion

  [SET_FILTERED_TICKETS](state, filteredTickets) {
    state.filteredTickets = filteredTickets;
  },
  [SET_MESSAGE_HISTORY](state, history) {
    state.history = history;
  },
  [SET_CLIENT_CHANNELS](state, channels) {
    state.channels = channels;
  },
  [UPDATE_PERSONAL_INFORMATION](state, personaInformation) {
    state.client.personal = personaInformation;
  },
  [ADD_SELECTED_TICKET](state, ticket) {
    state.selectedTickets.push(ticket);
  },
  [REMOVE_SELECTED_TICKET](state, ticket) {
    const result = state.selectedTickets.filter((selectedTicket) => {
      return selectedTicket.id !== ticket.id;
    });
    state.selectedTickets = result;
  },
  [SELECT_ALL_TICKETS](state, checked) {
    if (checked) {
      // state.selectedTickets = state.tickets.filter((ticket) => ticket.channel.id !== 1);
      const tickets = state.chunks ? [].concat(...state.chunks.map(c => c.tickets)) : []
      state.selectedTickets = tickets.filter((ticket) => ticket.channel.id !== 1);
    } else {
      state.selectedTickets = [];
    }
  },
  [CLEAR_SELECTED_TICKETS](state) {
    state.selectedTickets = [];
  },
  [ADD_PHONES_CLIENT](state, dataPhone) {
    state.client.phones.push(dataPhone);
  },
  [UPDATE_PHONES_CLIENT](state, dataPhone) {
    const index = state.client.phones.findIndex((item) => dataPhone.id === item.id);
    state.client.phones.splice(index, 1, dataPhone);
  },
  [REMOVE_PHONE_CLIENT](state, phoneId) {
    const index = state.client.phones.findIndex((item) => phoneId === item.id);
    state.client.phones.splice(index, 1);
  },
  [ADD_ADDRESSES_CLIENT](state, dataAddresse) {
    state.client.addresses.push(dataAddresse);
  },
  [REMOVE_ADDRESSES_CLIENT](state, addresseId) {
    const index = state.client.addresses.findIndex((item) => addresseId === item.id);
    state.client.addresses.splice(index, 1);
  },
  [UPDATE_ADDRESSES_CLIENT](state, dataAddresse) {
    const array = state.client.addresses.map((item) =>
      dataAddresse.id == item.id ? dataAddresse : item
    );
    state.client.addresses = array;
  },
  [ADD_EMAIL_CLIENT](state, dataEmail) {
    state.client.emails.push(dataEmail);
  },
  [UPDATE_EMAIL_CLIENT](state, dataEmail) {
    const array = state.client.emails.map((item) => (dataEmail.id == item.id ? dataEmail : item));
    state.client.emails = array;
  },
  [REMOVE_EMAIL_CLIENT](state, emailId) {
    const index = state.client.emails.findIndex((item) => emailId === item.id);
    state.client.emails.splice(index, 1);
  },
  [UPDATE_DATA_CUSTOM](state, dataCustom) {
    state.client.customs = dataCustom;
  },
  [SET_CLIENTS_WITH_SAME_NUMBER_FOUND](state, items) {
    state.clientsWithSameNumberFound = items;
  },
  [SET_CLIENTS_FOUND](state, items) {
    state.clientsFound = items;
  },
  [SET_CLEAN_RESULTS](state) {
    state.clientsFound = [];
  },
  [SET_CONTACTS_CLIENT](state, contacts) {
    const array = state.client.contacts;
    state.client.contacts = [...array, contacts];
  },
  [UPDATE_CONTACTS_CLIENT](state, contact) {
    console.log("actualizando", contact);
    const array = state.client.contacts.map((item) => (contact.id == item.id ? contact : item));
    state.client.contacts = array;
  },
  [DELETE_CONTACTS_CLIENT](state, contactId) {
    const array = _.remove(state.client.contacts, function (contact) {
      return contact.id != contactId;
    });
    state.client.contacts = array;
  },
  [SET_CALL_FINISH](state, call) {
    state.callEnded = call;
  },
  [SET_TICKET_DETAIL](state, data) {
    state.ticketDetail = data;
  },
  [SET_DIALING_TYPE](state, data) {
    state.dialingType = data;
  },
  [SET_CHANNEL_PERSON_TICKET](state, data) {
    state.channel_person = data;
  },
  [SET_SPEECH_CONFIG](state, config) {
    state.speechConfig = config;
  },
  [SET_PORTFOLIO_DETAIL](state, portfolioDetail) {
    state.portfolioDetail = portfolioDetail;
  },
  [SET_TYPIFICATIONS_TABLE_DATA](state, typificationsTableData) {
    state.typificationsTableData = typificationsTableData;
  },
  [SET_CAPTURE](state, data) {
    state.isCaptureded = data;
  },
  [SET_IS_SCHEDULE](state, schedule) {
    state.isSchedule = schedule;
  },
  [SET_LAST_OPENED_TICKET](state, openedTicket) {
    state.lastTicketOpened = openedTicket;
  },
  [SET_INTERACTIONS_CHANNEL](state, interactions) {
    state.interactionsChannel = interactions;
  },
  [SET_EMAIL_HISTORY](state, data) {
    state.emailHistory = data;
  },
  [SET_REFRESH_CHANNELS_ASTERISK_ID](state, asteriskId) {
    state.refreshChannelsAsteriskId = asteriskId;
  },
  [SET_EVENT_MESSAGING](state, data) {
    state.eventMessaging = data;
  },
  [SET_IS_VISITOR_TYPING](state, isTyping) {
    state.isVisitorTyping = isTyping;
  },
};
export default mutations;
